import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'flex-start',
      backgroundColor: '#e5e5e5',
    },
    mainContainer: {
      height: '100%',
      width: '100%',
      marginLeft: '8px',
      marginRight: '8px',
      marginTop: '52px',
      marginBottom: '6px',
      backgroundColor: '#ffffff',
      borderRadius: '4px',
    },
  },
  {
    name: 'Page',
  },
);
